export function isCoursePaymentSetupComplete(setup = {}) {
  const accountId = typeof setup?.accountId === 'string' ? setup.accountId.trim() : '';
  const onboardingComplete = setup?.onboardingCompleted === true
    || setup?.onboarding_completed === true
    || setup?.details_submitted === true;
  if (!accountId || !onboardingComplete) return false;
  if (setup?.transfersEnabled === false) return false;
  return true;
}

export function coursePaymentSetupMessage(label = 'course signup') {
  return `${label} is not available until the club has completed Stripe setup.`;
}
